import { render, staticRenderFns } from "./pdf-viewer.vue?vue&type=template&id=4aaa9b0d&scoped=true&"
import script from "./pdf-viewer.vue?vue&type=script&lang=ts&"
export * from "./pdf-viewer.vue?vue&type=script&lang=ts&"
import style0 from "./pdf-viewer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./pdf-viewer.vue?vue&type=style&index=1&id=4aaa9b0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaa9b0d",
  null
  
)

export default component.exports